import { apiCall } from './gqlClient';

const SENDATHLETEINTAKEEMAIL_QUERY = `
  mutation sendAthleteIntakeEmail($email: String!, $athleteName: String!, $providerName: String!, $intakeUrl: String!, $language: String) {
    sendAthleteIntakeEmail(email: $email, athleteName: $athleteName, providerName: $providerName, intakeUrl: $intakeUrl, language: $language)
    {
      sent
			sentAt
      ...fragments
    }
  }`;

export const sendAthleteIntakeEmailApiCall = async ({email, athleteName, providerName, intakeUrl, language}, fragments = null) => apiCall({ query: SENDATHLETEINTAKEEMAIL_QUERY, variables: {email, athleteName, providerName, intakeUrl, language}, fragments });

const SENDATHLETEPLANEMAIL_QUERY = `
  mutation sendAthletePlanEmail($email: String!, $athleteName: String!, $providerName: String!, $planPdfModel: JSON!, $intakeUrl: String, $language: String) {
    sendAthletePlanEmail(email: $email, athleteName: $athleteName, providerName: $providerName, planPdfModel: $planPdfModel, intakeUrl: $intakeUrl, language: $language)
    {
      sent
			sentAt
      ...fragments
    }
  }`;

export const sendAthletePlanEmailApiCall = async ({email, athleteName, providerName, planPdfModel, intakeUrl, language}, fragments = null) => apiCall({ query: SENDATHLETEPLANEMAIL_QUERY, variables: {email, athleteName, providerName, planPdfModel, intakeUrl, language}, fragments });
